import { dreamTeamKeys, nanumTeamKeys } from "./publicKeys";


export function calculateSetDeckPoint(playerInfos) {

    let totalSetDeckPoint = 0;

    const positionKeys = [
        'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
        'SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6', 
        'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 
        'RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'
    ]

    // const selectedTeam = playerInfos.selectedTeam;
    // const selectedTeamGroup = getTeamGroup(selectedTeam);
    
    for (const positionKey of positionKeys) {

        const player = playerInfos[positionKey];
        
        if (player) {

            const setDeckPoint = calculatePlayerSetDeckPoint(player, playerInfos)
            totalSetDeckPoint += setDeckPoint
        }
    }

    return totalSetDeckPoint;
}

export function calculatePlayerSetDeckPoint(player, playerInfos) {

    const selectedTeam = playerInfos.selectedTeam
    let setDeckPoint = 0
    const selectedTeamGroup = getTeamGroup(selectedTeam);
    const playerTeamGroup = getTeamGroup(player.team);

    if (player.team == "더미") {
        setDeckPoint += player.setDeckScore
    } else if (player.type === "올스타") {
        if ((player.team === selectedTeam) || (selectedTeamGroup && playerTeamGroup === selectedTeamGroup)) {
            setDeckPoint += player.setDeckScore * 2 || 0;
            setDeckPoint += player.specialTrainedStates.level || 0;
        }
    } else if(player.type === "골든글러브") {
        setDeckPoint += player.setDeckScore || 0;
        setDeckPoint += player.specialTrainedStates.level || 0;
    } else if (player.isFa) {
        if(player.isFa === selectedTeam){ 
            setDeckPoint += player.setDeckScore - 3 || 0;
            setDeckPoint += player.specialTrainedStates.level || 0;
        }
    } else if (player.team === selectedTeam) {
        setDeckPoint += player.setDeckScore || 0;
        setDeckPoint += player.specialTrainedStates.level || 0;
    } 
    
    return setDeckPoint;
}

function getTeamGroup(team) {
    if (dreamTeamKeys.includes(team)) {
        return 'dream';
    }
    if (nanumTeamKeys.includes(team)) {
        return 'nanum';
    }
    return null; // 어느 그룹에도 속하지 않음
};